import globalMethods from "@/globalMethods";
import {URLS} from "@/constants";


export default {
    namespaced: true,
    state: {
        sales: [],
        lastFilters: null,
        totalSum: "0",
        pagination: {
            page: 1,
            pageSize: 50,
            hasNext: false,
            totalCount: 0,
            isLoading: false,
        },
    },
    mutations: {
        setTotalSum(state, value) {
            state.totalSum = value;
        },
        setSales(state, { data, hasNext, totalCount, append }) {
            if (append) {
                const existingIds = new Set(state.sales.map(s => s.id));
                const newSales = data.filter(s => !existingIds.has(s.id));
                state.sales = [...state.sales, ...newSales];
            } else {
                state.sales = data;
            }
            state.pagination.hasNext = hasNext;
            state.pagination.totalCount = totalCount;
        },
        setPaginationLoading(state, isLoading) {
            state.pagination.isLoading = isLoading;
        },
        setPaginationPage(state, page) {
            state.pagination.page = page;
        },
        setLastFilters(state, filters) {
            state.lastFilters = filters;
        },
        resetPagination(state) {
            state.pagination.page = 1;
            state.pagination.hasNext = false;
            state.pagination.totalCount = 0;
        },
        // SSE mutations
        addSaleToList(state, sale) {
            // Добавить в начало списка если его ещё нет
            const exists = state.sales.some(s => s.id === sale.id);
            if (!exists) {
                state.sales.unshift(sale);
                state.pagination.totalCount++;
            }
        },
        removeSaleFromList(state, saleId) {
            const index = state.sales.findIndex(s => s.id === saleId);
            if (index !== -1) {
                state.sales.splice(index, 1);
                state.pagination.totalCount--;
            }
        },
        updateSaleInList(state, sale) {
            const index = state.sales.findIndex(s => s.id === sale.id);
            if (index !== -1) {
                state.sales.splice(index, 1, sale);
            }
        },
    },
    actions: {
        async searchSales({commit, state, rootState}, params) {
            const {personalData, company} = rootState;
            const {dateFrom, dateTo, shopId, search} = params;
            const headers = {
                role: personalData.role,
                companyId: company.companyData?.token,
            };
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (timezone) headers.timezone = timezone;

            const options = {
                method: "GET",
                credentials: 'include',
                headers,
            };

            commit("setLastFilters", {dateFrom, dateTo, shopId, search});
            commit("resetPagination");

            const searchParams = new URLSearchParams();
            searchParams.set("date-from", dateFrom);
            searchParams.set("date-to", dateTo);
            searchParams.set("page", 1);
            searchParams.set("page_size", state.pagination.pageSize);
            if (shopId && shopId !== "all") searchParams.set("shop-id", shopId);
            if (search) searchParams.set("search", search);

            const url = `${URLS.MODEL.SALE.SALES_SEARCH_URL}?${searchParams.toString()}`;
            return globalMethods.sendRequestToGetJson({
                url, options,
                successfulHandler: (data) => {
                    const sales = data.data || data;
                    const hasNext = data.has_next ?? false;
                    const totalCount = data.total_count ?? (Array.isArray(sales) ? sales.length : 0);
                    commit("setSales", {
                        data: Array.isArray(sales) ? sales : [],
                        hasNext,
                        totalCount,
                        append: false,
                    });
                    if (data.total_sum !== undefined) commit("setTotalSum", data.total_sum);
                    return {successfully: true};
                },
            });
        },
        async loadNextPage({commit, state, rootState}, params) {
            if (!state.pagination.hasNext || state.pagination.isLoading) return;
            const {personalData, company} = rootState;
            const {dateFrom, dateTo, shopId, search} = params;

            commit("setPaginationLoading", true);
            const nextPage = state.pagination.page + 1;
            commit("setPaginationPage", nextPage);

            const headers = {
                role: personalData.role,
                companyId: company.companyData?.token,
            };
            const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (timezone) headers.timezone = timezone;

            const searchParams = new URLSearchParams();
            searchParams.set("date-from", dateFrom);
            searchParams.set("date-to", dateTo);
            searchParams.set("page", nextPage);
            searchParams.set("page_size", state.pagination.pageSize);
            if (shopId && shopId !== "all") searchParams.set("shop-id", shopId);
            if (search) searchParams.set("search", search);

            const url = `${URLS.MODEL.SALE.SALES_SEARCH_URL}?${searchParams.toString()}`;
            const options = {
                method: "GET",
                credentials: 'include',
                headers,
            };

            const result = await globalMethods.sendRequestToGetJson({
                url, options,
                successfulHandler: data => data,
                errorHandler: () => { throw new Error(); },
            });
            const sales = result.data || result;
            commit("setSales", {
                data: Array.isArray(sales) ? sales : [],
                hasNext: result.has_next ?? false,
                totalCount: result.total_count ?? state.pagination.totalCount,
                append: true,
            });
            commit("setPaginationLoading", false);
            return {successfully: true};
        },
        // SSE actions
        addSale({ commit }, sale) {
            commit('addSaleToList', sale);
        },
        removeSale({ commit }, saleId) {
            commit('removeSaleFromList', saleId);
        },
        updateSale({ commit }, sale) {
            commit('updateSaleInList', sale);
        },
    },
};
